<template>
  <router-link
    :to="redirectTicket"
    class="d-flex notification-card"
  >
    <img v-image-fall-back :src="image" class="notification-card__image" />
    <div class="ml-3 d-flex flex-column justify-space-between pt-1 pb-1">
      <h4 class="text-h5 notification-card__title">
        Your visit is coming up! View and redeem your tickets here.
      </h4>
      <div class="d-flex flex-row c-pointer align-center">
        <h5 class="text-h5 notification-card__description mb-0">View Tickets</h5>
        <v-btn icon class="right-arrow">
          <v-icon small color="#FFFFFF">
            {{ mdiArrowRight }}
          </v-icon>
        </v-btn>
      </div>
    </div>
  </router-link>
</template>

<script lang="ts">
import Vue from 'vue'
import { mapGetters } from 'vuex'

import { getPath } from '@/utils/general-utils'
import { mdiArrowRight } from '@mdi/js'
import ImageFallBack from '@/utils/directive'
import { RedemptionObject } from '@/store/modules/redemption'

Vue.directive('image-fall-back', ImageFallBack)

export default Vue.extend({
  name: 'RedemptionNotification',
  data() {
    return {
      getPath,
      mdiArrowRight,
      image: require('@/assets/notification-logo.webp'),
    }
  },
  computed: {
    ...mapGetters([
      'tickets'
    ]),
    ticket(): RedemptionObject {
      return this.tickets?.find((ticket: RedemptionObject) => ticket.orderId === this.ticketId)
    },
    ticketId(): string {
      return this.$store.state.notification?.ticket[0]?.shopify_order_id
    },
    ticketLength(): number {
      return this.$store.state.notification?.ticket?.length
    },
    isSelfRedeem(): boolean {
      return this.ticket?.isSelfRedeem
    },
    isRedeemAll(): boolean {
      return this.ticket?.isRedeemAll
    },
    redirectTicket(): object {
      if (this.ticketLength === 1) {
        return { 
          name: 'RedemptionGroup', 
          params: { 
            id: this.ticketId, 
            selfRedeem: this.isSelfRedeem, 
            isRedeemAll: this.isRedeemAll,
          }, 
          query: { 
            expired: 'false', 
            redeemed: 'false' 
          } 
        }
      } else {
        return { 
          name: 'MyTickets',
        }
      }
    }
  },
  mounted() {
    this.$store.dispatch('loadMyTickets', { 
      page: 1, 
      redeemed: 'false', 
      expired: 'false', 
      ...this.$route.query 
    })
  }
})
</script>

<style lang="scss" scoped>
$border-radius: 10px;
$card-padding: 12px;
$card-padding-bottom: 20px;

.v-alert {
  padding: 0 !important;
}

.notification-card {
  box-shadow: 0px 3px 10px #a3a3a347;
  border-radius: $border-radius;
  background-color: white;
  text-decoration: none;
  padding: $card-padding;
  color: inherit !important;
  min-height: 110px;
  &__image {
    max-width: 80px;
    width: 80px;
    align-self: center;
    display: flex;
  }

  &__description {
    border-bottom: 1px solid var(--v-primary-base);
    color: var(--v-primary-base);
    margin-right: 0.75rem;
  }
}

.right-arrow {
  border-radius: 50% !important;
  width: 21px !important;
  height: 21px !important;
  background-color: var(--v-primary-base);
  z-index: $back-button-z-index;
}

@media #{map-get($display-breakpoints, "md-and-up")} {
  .notification-card {
    margin-top: 2rem !important;
  }
}
</style>
